
    <template>
      <div>
        <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

        <v-data-table
          :headers="headers"
          :items="[totalMapa]"      
          :sort-desc="true"      
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">            
              <v-row>
                <v-col cols="12" sm="2" md="2"> <v-toolbar-title>Mapa Estatístico</v-toolbar-title></v-col>
              <v-col cols="12" sm="2" md="2">
                  <v-select
                    :items="Listaranoslectivo"
                    v-model="anolectivo"
                    item-value="descricao"
                    item-text="novadescricao"
                    label="Selecione o Ano lectivo"
                    outlined
                    return-object
                  ></v-select>      
      </v-col>
      <v-col cols="12" sm="2" md="2">
                  <v-select
                    :items="classes"
                    v-model="classe"
                    :disabled="!anolectivo"
                    item-value="id"
                    item-text="descricao"
                    label="Selecione a classe"
                    @change="loadTurmas()"
                    outlined
                    return-object
                  ></v-select>      
      </v-col>
      <v-col cols="12" sm="2" md="2">
                  <v-select
                    :items="turmas"
                    v-model="turma"
                    :disabled="!classe"
                    item-value="pkTurma"
                    item-text="descricao"
                    label="Selecione a Turma"
                    outlined
                    return-object
                  ></v-select>      
      </v-col>
      <v-col cols="12" sm="2" md="2">
              <v-select
                :items="trimestres"
                v-model="trimestre"
                :disabled="!turma"
                item-value="id"
                item-text="descricao"
                @change="carregarMapaFrequencia()"
                label="Selecione o Trimestre"
                outlined
                return-object
              ></v-select>      
  </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn large fab color="#006699" @click="comporHTML()"
                            :disabled="!mapafrequencia.length"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <v-icon color="white">print</v-icon>
                              </v-btn>
                          </template>
                          <span>Clique aqui para visualizar o PDF</span>
                      </v-tooltip>
        </v-col>
    </v-row>
              <v-spacer></v-spacer>    
            </v-toolbar>
    </template>          
          <template v-slot:no-data>
            no data
          </template>
        </v-data-table>
      
         
      </div>
      </template>
<script>
import axios from '../../../../plugins/axios'
import impressao from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    relatorio: '',
    mapafrequencia: {items:[],totais:null},
    html: ``,
    isLoading: true,
    Listaranoslectivo: [],
    anolectivo: null,
    totalMapa: [],
    turmas: [],
    turma: null,
    trimestres:[
  {id:1,descricao:'Iº'},
  {id:2,descricao:'IIº'},
  {id:3,descricao:'IIIº'}
],
trimestre: null,
    classes: [
              {id:1,descricao:'10ª'},
              {id:2,descricao:'11ª'},
              {id:3,descricao:'12ª'},
              {id:4,descricao:'13ª'}
             ],
             classe: null,
    headers: [
      {
        text: 'Matriculados',
        align: 'left',
        sortable: false,
        value: 'mat_total'
      },
       { text: 'Avaliados', value: 'ava_total' },
      { text: 'Desistentes', value: 'des_total' }
    ],

  }),
  computed: {
  },
  watch: {
  },
  created  () {
    this.carregarRelatorio()   
    this.carregarAnosLectivo() 
  },
  methods: {
    async carregarAnosLectivo () {
      try {
        this.isLoading = true
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar os anos lectivos' })    
        this.isLoading = false
      } finally {
        this.sair()
      }
    },
    async carregarRelatorio () {
      try {
        this.isLoading = true
        this.relatorio = await axios.get('/obterRelatorioByDescricao/me').then(res => res.data) 
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o relatório' })
      }
    },
    async carregarMapaFrequencia () {
      try {     
        this.isLoading = true   
        this.mapafrequencia = await axios.get('/mapaestatistico/'+ this.turma.pkTurma +'/'+ this.trimestre.id).then(res => res.data) 
        this.carregarTotalMapa()
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o mapa de frequência' })
      } finally {
        this.sair()
      }
    },
    async carregarTotalMapa () {
      try {     
        this.isLoading = true   
        this.totalMapa = await axios.get('/mapaestatisticoTotal/'+ this.turma.pkTurma +'/'+ this.trimestre.id).then(res => res.data) 
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o mapa de frequência' })
      } finally {
        this.sair()
      }
    },
    async loadTurmas(){
      try {
        this.isLoading = true
        this.turmas = await axios.get('/turmaFindByAnoLectivoClasse/'+ this.anolectivo.descricao +'/'+ this.classe.id).then(res => res.data) 
      } catch (error) {
        this.isLoading = false
        Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar as turmas' })
      } finally {
        this.isLoading = false
      }
    },
    comporHTML () {
      try {
        this.isLoading = true
        this.html = this.relatorio[0].documento
        let documentoiter = this.relatorio[0].documentoiteracao1
        
        this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('instituicaodescricao').toUpperCase())
        this.html = this.html.replace(/{{logotipo}}/g, ls.get('logotipo'))
        this.html = this.html.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)

        this.html = this.html.replace(/{{turma}}/g, this.turma.descricao)
        this.html = this.html.replace(/{{periodo}}/g, this.turma.periodo)
        this.html = this.html.replace(/{{classe}}/g, this.classe.descricao)

        this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
        this.html = this.html.replace(/{{sala}}/g, this.turma.sala)

        this.html = this.html.replace(/{{dataactual}}/g, this.correntDate()) 

        this.html = this.html.replace(/{{mat_masc}}/g, this.totalMapa.mat_masc)
        this.html = this.html.replace(/{{mat_fem}}/g, this.totalMapa.mat_fem)
        this.html = this.html.replace(/{{mat_total}}/g, this.totalMapa.mat_total)

        this.html = this.html.replace(/{{ava_masc}}/g, this.totalMapa.ava_masc)
        this.html = this.html.replace(/{{ava_fem}}/g, this.totalMapa.ava_fem)
        this.html = this.html.replace(/{{ava_total}}/g, this.totalMapa.ava_total)

        this.html = this.html.replace(/{{des_masc}}/g, this.totalMapa.des_masc)
        this.html = this.html.replace(/{{des_fem}}/g, this.totalMapa.des_fem)
        this.html = this.html.replace(/{{des_total}}/g, this.totalMapa.des_total)
       let totalpercent_neg = 0
       let totalpercent_pos = 0
        let dados = ``
        let i=0
        this.mapafrequencia.forEach(element => {
          let iteracao = documentoiter
          i++
          if(i === 1){
            iteracao = this.relatorio[0].documentoiteracao2
            iteracao = iteracao.replace(/{{totaldisciplinas}}/g, this.mapafrequencia.length)
          } 
            totalpercent_neg += Math.round((parseInt(element.neg_total)*100)/parseInt(this.totalMapa.mat_total))
          
          iteracao = iteracao.replace(/{{indice}}/g, i)
          iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)

          iteracao = iteracao.replace(/{{neg_masc}}/g, element.neg_masc)
          iteracao = iteracao.replace(/{{neg_fem}}/g, element.neg_fem)
          iteracao = iteracao.replace(/{{neg_total}}/g, element.neg_total)
          iteracao = iteracao.replace(/{{neg_percentual}}/g, Math.round((parseInt(element.neg_total)*100)/parseInt(this.totalMapa.mat_total)))

          totalpercent_pos += Math.round((parseInt(element.pos_total)*100)/parseInt(this.totalMapa.mat_total))
          iteracao = iteracao.replace(/{{pos_masc}}/g, element.pos_masc)
          iteracao = iteracao.replace(/{{pos_fem}}/g, element.pos_fem)
          iteracao = iteracao.replace(/{{pos_total}}/g, element.pos_total)
          iteracao = iteracao.replace(/{{pos_percentual}}/g, Math.round((parseInt(element.pos_total)*100)/parseInt(this.totalMapa.mat_total)))       
    
          
          
          dados += iteracao
      })
      let sumTotalPercent = (totalpercent_neg + totalpercent_pos)
      dados = dados.replace(/{{neg_percentual_turma}}/g, (totalpercent_neg === 0 ? 0 : Math.round(((totalpercent_neg*100)/sumTotalPercent))))
      dados = dados.replace(/{{pos_percentual_turma}}/g, (totalpercent_pos === 0 ? 0 : Math.round(((totalpercent_pos*100)/sumTotalPercent))))

      this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
      this.html = this.html.replace(/{{dados}}/g, dados)
        let options = { 'format': 'A4',
        'border': {
          'right': '12mm',
          'left': '12mm'
        },
        'header': {
          'height': '10mm',
          'contents': { first: '' } },
        'footer': {
          'height': '10mm'

        } }
        impressao.htmlToPDF(this.html,options,ls.get('urlReport'),ls.get('idPessoa'))
      } catch (error) {
        this.sair()
        Swal.fire({icon: 'error',title: '', text: 'Ocorreu um erro ao abrir o documento'})
      } finally {
        this.sair()
      }
    },   
    sair(){ this.isLoading =false },
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return 'Luanda, ' + data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    }
  }
}

</script>
